import { render, staticRenderFns } from "./BscMarketForecastWeekYield.vue?vue&type=template&id=1a9ee0f2"
import script from "./BscMarketForecastWeekYield.vue?vue&type=script&lang=js"
export * from "./BscMarketForecastWeekYield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports